export const firebaseConfig = {
    apiKey: "AIzaSyCYKMjjz_1pzHW24E3Vg3dxwfgzVWGuxog",
    authDomain: "jncl-71437.firebaseapp.com",
    databaseURL: "https://jncl-71437.firebaseio.com",
    projectId: "jncl-71437",
    storageBucket: "jncl-71437.appspot.com",
    messagingSenderId: "927671482000"
};


// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/environments/firebase.config.ts